import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class CustomPaginatorService extends MatPaginatorIntl {

  changes = new Subject<void>();
  currentLang
  constructor(private translate: TranslateService, private baseService: BaseService) {
    super();
    this.currentLang = this.baseService.getCurrentLanguage();
    this.setTranslations();
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
      this.setTranslations();
      this.changes.next(); // update texts
    });
  }

  setTranslations() {
    this.itemsPerPageLabel = this.translate.instant('PAGINATOR.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translate.instant('PAGINATOR.NEXT_PAGE');
    this.previousPageLabel = this.translate.instant('PAGINATOR.PREVIOUS_PAGE');
    this.firstPageLabel = this.translate.instant('PAGINATOR.FIRST_PAGE');
    this.lastPageLabel = this.translate.instant('PAGINATOR.LAST_PAGE');

    // numbers style
    const numberFormatter = new Intl.NumberFormat(this.currentLang);

    this.getRangeLabel = (page: number, pageSize: number, length: number): string => {
      if (length === 0) {
        return this.translate.instant('PAGINATOR.NO_RESULTS');
      }
      const startIndex = page * pageSize + 1;
      const endIndex = Math.min(length, (page + 1) * pageSize);

      return this.translate.instant('PAGINATOR.RANGE_LABEL', {
        start: numberFormatter.format(startIndex),
        end: numberFormatter.format(endIndex),
        length: numberFormatter.format(length),
      });
    };
  }
}
